import { date, object } from 'yup';
import { EuroValueSigned } from '../../common';

export type IPaymentCreate = {
  amount: number;
  timestamp: Date;
};

export const IPaymentCreateSchema = object({
  amount: EuroValueSigned.required(),
  timestamp: date().required(),
});
